import * as React from 'react';

import { useTranslation } from 'react-i18next';

import { TgIcon, PhoneHelpIcon, EmailHelpIcon } from '@icons';
import { getBrandSupport } from '@utils/get-brand-support.ts';


import { Button } from '@components/button';

import * as Styled from './support.styled.ts';

const SupportPage = () => {
	const { t } = useTranslation('help');

	const supportData = getBrandSupport();

	return (
		<Styled.Wrapper>
			<Styled.Container>
				<Styled.Header>
					<Styled.Title>{t('help')}</Styled.Title>
				</Styled.Header>
				<Styled.Body>
					<Styled.Text>
						{t('have_trouble')} <br />
						{t('ask_help')}
					</Styled.Text>
					<Styled.Links>
						{supportData.tg && (
							<Styled.SupportButton to={`https://t.me/${supportData.tg}`} target='_blank' $color='#299FDA'>
								<Button>
									<TgIcon />@{supportData.tg}
								</Button>
							</Styled.SupportButton>
						)}
						{supportData.phone && (
							<Styled.SupportButton to={`tel:${supportData.phone}`} target='_blank'>
								<Button color='dark'>
									<PhoneHelpIcon />
									{supportData.phoneText ? supportData.phoneText : supportData.phone}
								</Button>
							</Styled.SupportButton>
						)}
						{supportData.mail && (
							<Styled.SupportButton to={`mailto:${supportData.mail}`} target='_blank'>
								<Button color='dark'>
									<EmailHelpIcon />
									{supportData.mail}
								</Button>
							</Styled.SupportButton>
						)}
					</Styled.Links>
				</Styled.Body>
			</Styled.Container>
		</Styled.Wrapper>
	);
};

export default SupportPage;
